<div class="w-[270px] rounded-xl flex flex-col overflow-hidden bg-black">

    <!-- THUMBNAIL -->
    @if(view3dDisplayEnabled()) {

        @if(thumbnail){
            <img [src]="thumbnail" [alt]="'thumbnail-'+ node.id" class="h-[124px] pointer-events-auto object-cover">
        }
        @else {
        <!-- LOADER -->
            <div class="h-[124px] flex items-center bg-black">

                <div class="flex-col gap-4 w-full flex items-center justify-center">

                    <div
                        class="size-8 border-2 relative text-white/80 text-4xl animate-spin border-gray-300/50 flex items-center justify-center border-t-white rounded-full">
                    </div>

                </div>

            </div>
        }
    }

    <!-- CUSTOM TEXT -->
    @if (customText) {

        <div class="flex flex-col gap-y-1 items-center bg-semiblack border-b border-b-dark-gray" [class]="view3dDisplayEnabled() ? 'py-1.5' : 'py-2.5'">
            <p class="font-semibold block text-xs text-white text-center whitespace-pre" [innerHTML]="customText">
            </p>
        </div>
    }
    <!-- CONTENT -->
    <div class="flex flex-col gap-y-1 items-center bg-semiblack " [class]="view3dDisplayEnabled() ? 'py-1.5' : 'py-2.5'">

        <p
            class="font-semibold block uppercase text-white"
            [class.text-xs]="(section?.length ?? 0) <= 25"
            [style.font-size]="(section?.length ?? 0) > 25 ? '0.6rem' : null"
            [style.line-height]="(section?.length ?? 0) > 25 ? '0.6rem' : null">

            <span [class]="isPremium ? 'text-vip' : 'opacity-50'" class="font-light">
                {{translation.getText('general', 'section')}}
            </span>

            {{ section }}

        </p>

        @if (node.type === Nodes.Seat) {

            <ng-container>

                <p
                    class="font-semibold text-white block uppercase"
                    [class.text-xs]="(row?.length ?? 0) <= 25 && (seat?.length ?? 0) <= 25"
                    [style.font-size]="(row?.length ?? 0) > 25 || (seat?.length ?? 0) > 25 ? '0.6rem' : null"
                    [style.line-height]="(row?.length ?? 0) > 25 || (seat?.length ?? 0) > 25 ? '0.6rem' : null">

                    <span [class]="isPremium ? 'text-vip' : 'opacity-50'" class="font-light"> {{translation.getText('general', 'row')}}</span>

                    {{ row }}

                    &nbsp;

                    <span [class]="isPremium ? 'text-vip' : 'opacity-50'" class="font-light">{{translation.getText('general', 'seat')}}</span>

                    {{ seat }}

                </p>

            </ng-container>

        }

    </div>

    <!-- CUSTOM PRICE -->
    @if (customPrice && !isPremium) {

        <div class="flex flex-col items-center justify-center py-2.5">
            <p class=" text-white block uppercase">
                <span class="opacity-50">{{translation.getText('popup', 'from')}}</span>
                &nbsp;
                <span class="font-semibold">{{customPrice}}</span>
            </p>
        </div>
    }


    <!-- PRICE & BENEFITS -->
    @if (isPremium) {

        <ng-container>

            <!-- GRADIENT -->
            <div class="h-0.5 w-full bg-gradient-to-r from-vip/30 via-vip to-vip/30"></div>

            <!-- BENEFITS & PRICE -->
            <div class="flex flex-col items-center justify-center py-1.5">

                <!-- PRICE -->
                @if (customPrice || price) {

                    <p class="font-semibold text-white block uppercase text-sm">

                        <span class="font-light text-vip">{{translation.getText('popup', 'from')}}&nbsp;</span>

                        {{ customPrice ?? (price | currency:'USD') }}
                        
                    </p>
                }

                <!-- BENEFITS -->
                <div class="grid grid-cols-2 grid-rows-2 w-full items-center justify-items-center my-4 px-16 gap-y-1.5">

                    <!-- FIRST ROW ICONS -->

                    <!-- SPACE INDOORS -->
                    <i class="mx-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                            <path id="Icon_material-outline-meeting-room" data-name="Icon material-outline-meeting-room"
                                d="M28.5,28.5V6h-6V4.5H7.5v24h-3v3h18V9h3V31.5h6v-3Zm-9,0h-9V7.5h9ZM15,16.5h3v3H15Z"
                                transform="translate(-4 -4)" fill="#cba57f" stroke="#131512" stroke-width="1" />
                        </svg>
                    </i>

                    <!-- FOOD SERVICE -->
                    <i class="mx-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="22" viewBox="0 0 31 22">
                            <path id="Icon_material-outline-room-service" data-name="Icon material-outline-room-service"
                                d="M28.47,25.5H3v3H33v-3ZM31.5,24A13.518,13.518,0,0,0,20.76,11.685a3,3,0,1,0-5.52,0A13.518,13.518,0,0,0,4.5,24ZM18,14.37a10.5,10.5,0,0,1,9.75,6.615H8.25A10.5,10.5,0,0,1,18,14.37Z"
                                transform="translate(-2.5 -7)" fill="#cba57f" stroke="#121412" stroke-width="1" />
                        </svg>
                    </i>

                    <!-- SECOND ROW TEXTS -->
                    <p class="text-white text-[10px] font-semibold text-center max-w-12 leading-2.5">
                        <span>
                            {{translation.getText('popup', 'space_indoors_text')}}
                        </span>
                    </p>

                    <p class="text-white text-[10px] font-semibold text-center max-w-12 leading-2.5">
                        <span>
                            {{translation.getText('popup', 'food_service_text')}}
                        </span>
                    </p>

                </div>

            </div>

        </ng-container>

    }

</div>
